import React, { useContext } from "react";
import ThemeContext from "~/contexts/ThemeContext";

type ChevronRightProps = {
  className?: string;
  color?: string;
};

const ChevronRight: React.FC<ChevronRightProps> = ({ className, color }) => {
  const { template } = useContext(ThemeContext);
  const iconColor = color || template.global.icon.colour;

  return (
    <svg
      className={className}
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.375 6.25L15.625 12.5L9.375 18.75"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronRight;
